<template>
    <div class="container">
        <MercenaryHeader :title="'스카우트 현황'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div class="btn_tab_container_wrapper">
            <div class="btn_tab_container">
                <div @click="setCurTab(CUR_TAB.INTEREST)" :class="{ active: curTab === CUR_TAB.INTEREST }" class="btn_tab_item">관심 선수</div>
                <div @click="setCurTab(CUR_TAB.RECEIVED_REQUEST)" :class="{ active: curTab === CUR_TAB.RECEIVED_REQUEST }" class="btn_tab_item">받은 입단 요청서</div>
            </div>
        </div>
        <template v-if="curTab === CUR_TAB.INTEREST">
            <div class="content_container">
                <div class="total_count">총 <span style="font-weight: 700; color: var(--color-main);">{{ favoritePlayerCnt }}명</span>의 선수가 있습니다</div>
                <div class="favorite_player_list">
                    <div @click="$Util.showProfile(each.to_member.idx, 0)" :style="{ paddingTop: i === 0 ? '0' : '10px' }" v-for="each, i in favoritePlayerList" :key="i">
                        <div class="favorite_player_item">
                            <div>
                                <ProfileImage style="width: 40px" :imagePath="each.to_member.image_path"></ProfileImage>
                            </div>
                            <div style="font-size: 14px; font-weight: 700;">
                                {{ each.to_member.nic_name }} <span style="font-weight: 500; color: var(--color-main);">{{ each.to_member.position }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="curTab === CUR_TAB.RECEIVED_REQUEST">
            <div class="content_container">
                <div class="total_count">총 <span style="font-weight: 700; color: var(--color-main);">{{ receivedRequestCnt }}개</span>의 입단 요청서가 있습니다</div>
                <div class="request_list">
                    <div class="request_item" :style="{ paddingTop: i === 0 ? '0' : '30px' }" v-for="each, i in receivedRequestList" :key="i">
                        <CommonRequestForm :userInfo="each"></CommonRequestForm>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

const CUR_TAB = {
    INTEREST: 'INTEREST',
    RECEIVED_REQUEST: 'RECEIVED_REQUEST'
}
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import CommonRequestForm from '@/components/common/CommonRequestForm'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'CurrentScout',
    components: { MercenaryHeader, ProfileImage, CommonRequestForm },
    props: {
        parentType: {
            type: String,
            default: 'favorite'
        }
    },
    created() {
        if (this.parentType === 'request') {
            this.curTab = CUR_TAB.RECEIVED_REQUEST
        } else {
            this.curTab = CUR_TAB.INTEREST
        }
        this.getMyCurrentScout()
    },
    data() {
        return {
            CUR_TAB: CUR_TAB,
            curTab: CUR_TAB.INTEREST,
            favoritePlayerList: [],
            receivedRequestList: [],
            favoritePlayerCnt: 0,
            receivedRequestCnt: 0,
        }
    },
    methods: {
        setCurTab(tab) {
            this.curTab = tab
            this.getMyCurrentScout()
        },
        async getMyCurrentScout() {
            const parameters = {}
            parameters.is_detail = true
            const res = await this.$Axios.get('/api/coach/scouting/my_current', { params: parameters })
            if (res.data.code === ResponseCode.SUCCESS) {
                this.favoritePlayerList = res.data.favorite_player_list
                this.receivedRequestList = res.data.received_request_list
                this.favoritePlayerCnt = res.data.favorite_player_cnt
                this.receivedRequestCnt = res.data.received_request_cnt
            }
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}

.content_container {
    flex: 1;
    overflow-y: auto;
    padding: 0 12px;
}

.btn_tab_container_wrapper {
    padding: 0 12px;
    padding-bottom: 14px;
}

.btn_tab_container {
    display: flex;
    background: #0000000D;
    border-radius: 12px;
    padding: 5px;
}

.btn_tab_item {
    flex: 1;
    text-align: center;
    padding: 4px;
    line-height: 24px;
    font-size: 12px;
    font-weight: 700;
    border-radius: 10px;
    color: #797979;
}

.btn_tab_item.active {
    background: #fff;
    color: #210f03;
}

.total_count {
    font-weight: 700;
    margin-top: 16px;
}

.favorite_player_list {
    margin-top: 20px;
}

.favorite_player_item {
    display: flex;
    gap: 8px;
    align-items: center;
    border-bottom: 1px solid #D9D9D980;
    padding-bottom: 10px;
}

.request_list {
    margin-top: 31px;
}

.request_item {
    padding-bottom: 30px;
    border-bottom: 1px solid #eaeaea;
}
</style>